import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Btn, CustomModal, InputNumeroInteiro, InputText } from '../../../../../components'
import NumberFormat from 'react-number-format'
import { errorHandler } from '../../../../../services/util/error.service'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import EstoqueHttp from '../../../../../services/api/https/estoque/Estoque.http'

const LOAD_MESSAGE = {
  NONE: 'NONE',
  CREATE: 'Criando posição',
  UPDATE: 'Atualizando posição',
  SUCCESS: 'Posição salva com sucesso',
}

const INITIAL_STATE = {
  posicao: {
    id: undefined,
    endereco: '',
    sequencia: '',
    capacidade: '',
  },
  savedPosicao: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

function toInputValue(value) {
  return value === null || value === undefined ? '' : String(value)
}

const CapacityInput = ({
  value,
  onChange,
  width = '100%',
  marginTop = 20,
  disabled = false,
  placeholder = null,
  format = null,
  id = undefined,
}) => (
  <NumberFormat
    id={id}
    placeholder={placeholder}
    disabled={disabled}
    style={{
      width,
      outline: 'none',
      border: '1px solid  #F1F1F1',
      height: 30,
      marginTop: 3,
      backgroundColor: disabled ? 'rgba(239, 239, 239, 0.3)' : 'rgba(255, 255, 255, 0.9)',
      padding: 10,
    }}
    isNumericString={true}
    format={format}
    allowNegative={false}
    value={value}
    isAllowed={({ value: nextValue }) =>
      nextValue === '' || /^[1-9]\d{0,5}$/.test(nextValue)
    }
    onPaste={event => event.preventDefault()}
    onValueChange={({ value: nextValue }) => {
      if (onChange && nextValue !== toInputValue(value)) onChange(nextValue)
    }}
  />
)

const ModalCadastroPosicaoEstoque = ({
  data,
  show,
  onModalSave,
  onModalClose,
  dispatch,
  estoqueId,
  selectedTp,
  sequenciaBegin,
}) => {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    if (show) {
      if (data.id) {
        data.sequencia = data.sequencia.toString()
        data.capacidade = data.capacidade.toString()
      }
      setState(prevState => ({
        ...prevState,
        posicao: data.id
          ? { ...data }
          : { ...INITIAL_STATE.posicao, sequencia: (sequenciaBegin + 1).toString() },
      }))
    }
  }, [show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.CREATE:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        savePosicao(state.posicao, selectedTp, estoqueId)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        dispatch(showMessageBox(state.loadingMessage, null))
        onModalSave(state.savedPosicao)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      setState(prevState => ({
        ...prevState,
        loadingMessage: LOAD_MESSAGE.NONE,
        errorMessage: null,
      }))
    }
  }, [state.errorMessage])

  // Events
  const onBtnSalvarClicked = posicao => {
    if (
      !posicao.endereco.trim().length ||
      !posicao.capacidade.trim().length ||
      !posicao.sequencia.trim().length
    )
      setState(prevState => ({ ...prevState, errorMessage: 'Preencha todos os campos' }))
    else if (!Number(posicao.sequencia))
      setState(prevState => ({ ...prevState, errorMessage: 'A sequencia não pode ser igual a 0' }))
    else if (!Number(posicao.capacidade))
      setState(prevState => ({ ...prevState, errorMessage: 'A capacidade não pode ser igual a 0' }))
    else setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.CREATE }))
  }

  const onFormChange = (name, value) => {
    setState(prevState => {
      prevState.posicao[name] = value
      return { ...prevState }
    })
  }

  // Helper
  const savePosicao = (posicao, selectedTp, estoqueId) => {
    const { selected, ...newPosicao } = posicao
    newPosicao.endereco = newPosicao.endereco.trim()
    EstoqueHttp.savePosicaoEstoque(selectedTp, { estoque_id: estoqueId, ...newPosicao })
      .then(posicao =>
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.SUCCESS,
          savedPosicao: posicao,
        })),
      )
      .catch(err =>
        setState(prevState => ({
          ...prevState,
          errorMessage: errorHandler(err),
          loadingMessage: LOAD_MESSAGE.NONE,
        })),
      )
  }

  // Render
  return (
    <CustomModal
      header={state.posicao.id ? 'Editar Posição' : 'Nova Posição'}
      isVisible={show}
      onClose={onModalClose}
      width={450}
    >
      <form className="p-grid" onSubmit={e => e.preventDefault()}>
        <div className="p-col-12">
          <span style={{ color: '#14B0BF', fontSize: '0.8rem' }}>(*) Campo Obrigatório</span>
        </div>
        <div className="p-col-12">
          <InputText
            label="Endereço* :"
            marginTop={10}
            value={state.posicao.endereco}
            onChange={value => onFormChange('endereco', value)}
            required={true}
          />
        </div>
        <div className="p-col-6">
          <InputNumeroInteiro
            placeholder="1"
            label="Sequencia* :"
            marginTop={10}
            value={state.posicao.sequencia}
            onChange={value => onFormChange('sequencia', value)}
            required={true}
          />
        </div>
        <div className="p-col-6">
          <div style={{ textAlign: 'left', marginTop: 10 }}>
            <label style={{ fontSize: '0.8rem', color: '#14B0BF', display: 'block' }}>
              Capacidade em Pallets* :
            </label>
            <CapacityInput
              value={state.posicao.capacidade}
              onChange={value => onFormChange('capacidade', value)}
            />
          </div>
        </div>
        <div className="p-col-12" style={{ paddingTop: 32, textAlign: 'end' }}>
          <Btn onClick={() => onBtnSalvarClicked(state.posicao)}>Salvar</Btn>
        </div>
      </form>
    </CustomModal>
  )
}

export default connect()(ModalCadastroPosicaoEstoque)
